<template>
    <div>
        <van-nav-bar title="旅行的回忆" />
        <van-image round width="24rem" height="24rem" fit="fill"
                   src="/static/DJI_0665.jpg" @click="show=!show"/>
        <van-image-preview v-model="show" :images="images" @change="onChange" :closeable="true">
            <template v-slot:index>Page: {{ index }}</template>
        </van-image-preview>
        <div class="text">澳大利亚旅行</div>
        <van-divider />
        <van-icon name="/static/police_record.png" />
        <a href="http://beian.miit.gov.cn/"  style="color:#f72b07" target="_blank">{{beianNumber}}</a>
    </div>
</template>

<script>
import { Divider, ImagePreview, Image, NavBar } from 'vant';

export default {
    name: 'Beian',
    data () {
        return {
            // beianNumber: '浙ICP备20004897号-1',
            beianNumber: '沪ICP备20014434号-1',
            show: false,
            index: 0,
            images: [
                '/static/DJI_0665.jpg',
                '/static/DSC05940.jpg',
                '/static/DSC06953.jpg'
            ]
        }
    },
    methods: {
        onChange(index) {
            this.index = index;
        }
    },
    mounted() {
        console.log(document.domain);
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Beian.vue